export const PACKAGE_ROUTING = [
    {
        path: '/package',
        name: 'package',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Kiện hàng', pathName: 'package', icon: 'fa fa-codepen' },
            ]
        },
        component: () => import('./Package.vue'),
        redirect: { name: 'package-index' },
        children: [
            { 
                path: '/kien-hang.html',
                name: 'package-index',
                component: () => import('./components/main-package/MainPackage.vue')
            }
        ]
    }
];